import { PCFRequestStatus } from '../enums/pcf-request';

export const COMPONENT_TASKS_COMPLETE_STATUS_MAPPING = [
  PCFRequestStatus.Complete,
  PCFRequestStatus.Updated,
  PCFRequestStatus.Outdated,
];

export const PRODUCT_TASKS_TABLE_PAGE_SIZE = 50;
export const COMPONENT_TASKS_TABLE_PAGE_SIZE = 50;
export const CERTIFICATE_TASKS_TABLE_PAGE_SIZE = 50;
export const EXPORT_PRODUCT_TASKS_TABLE_PAGE_SIZE = 50;
